var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-seach-wrap"},[(_vm.activeName == 'active')?_c('Active'):_vm._e(),_vm._v(" "),(_vm.activeName == 'setting')?_c('getSetting'):_vm._e(),_vm._v(" "),(_vm.activeName == 'audit')?_c('Audit'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2048b2f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/assemble/index.vue
// module id = null
// module chunks = 